import React from 'react';
import { Check } from 'lucide-react';
export function Comparison() {
  const comparisons = [{
    title: 'Frameless / Euro',
    bestFor: ['Modern bathroom remodels', 'Showcasing tile or stone', 'Open, airy bathroom designs', 'Homeowners wanting minimal hardware', 'Luxury master bathrooms']
  }, {
    title: 'Semi-Frameless / Framed',
    bestFor: ['Traditional or transitional bathrooms', 'Practical support with a clean look', 'Budget-conscious upgrades', 'Replacing older framed doors', 'Tub and shower combinations']
  }, {
    title: 'Sliding / Bypass',
    bestFor: ['Smaller bathrooms', 'Tub enclosures', 'Openings without swing-door clearance', 'Guest bathrooms', 'Efficient daily use']
  }, {
    title: 'Fixed Panel / Walk-In',
    bestFor: ['Low-curb or curbless showers', 'Accessible bathroom layouts', 'Minimalist designs', 'Open-concept shower spaces', 'Barrier-free entry goals']
  }];
  return <section className="py-20 bg-white" data-id="element-1502">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1503">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1504">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-1505">
            Which Glass Shower Door Is Right for Your Bathroom?
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-1506">
          {comparisons.map((item, i) => <div key={i} className="bg-gray-50 p-8 rounded-2xl border border-gray-100 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1507">
              <h3 className="text-xl font-bold text-navy mb-6 pb-4 border-b border-gray-200" data-id="element-1508">
                {item.title}
              </h3>
              <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4" data-id="element-1509">
                Best for:
              </p>
              <ul className="space-y-3" data-id="element-1510">
                {item.bestFor.map((bullet, j) => <li key={j} className="flex items-start gap-2" data-id="element-1511">
                    <Check className="w-5 h-5 text-primary shrink-0" data-id="element-1512" />
                    <span className="text-gray-700" data-id="element-1513">{bullet}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="max-w-2xl mx-auto text-center bg-glass p-6 rounded-2xl mb-8 anim-on-scroll" data-id="element-1514">
          <p className="text-navy font-medium" data-id="element-1515">
            Kosin's Glass can review your layout, measurements, bathroom style
            and usage needs to recommend the best shower glass option.
          </p>
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1516">
          <a href="#quote-form" className="inline-flex items-center justify-center bg-navy hover:bg-navy-800 text-white font-semibold py-4 px-8 rounded-xl transition-colors" data-id="element-1517">
            Help Me Choose My Shower Door
          </a>
        </div>
      </div>
    </section>;
}